import * as fromDatatype from "../datatype-library/index";

export interface bl_alg_cc_qc_monthly_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.TextDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	completed_status : boolean;
    type : fromDatatype.VarcharDatatypeInterface;
    start_date : fromDatatype.TimestampTzDatatypeInterface;
    end_date : fromDatatype.TimestampTzDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_alg_cc_qc_monthly_hdr_RowClass
	implements bl_alg_cc_qc_monthly_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.TextDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	completed_status : boolean;
    type : fromDatatype.VarcharDatatypeInterface;
    start_date : fromDatatype.TimestampTzDatatypeInterface;
    end_date : fromDatatype.TimestampTzDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
